import React, { useRef } from "react";
import styles from "./ImagePreview.module.css";
import { useDispatch } from "react-redux";
import * as createPostSlice from "../../../app/slices/createPostSlice";

function ImagePreview({ images }) {
  const dispatch = useDispatch();
  const imgNum = images.length;
  const imageInputRef = useRef(null);

  const handleImages = (e) => {
    let files = Array.from(e.target.files);
    if (files.length + images.length > 5) {
      alert("You can upload only 5 images");
      return;
    }
    files.forEach((img) => {
      if (!img.type.startsWith("image")) return;
      const reader = new FileReader();
      reader.readAsDataURL(img);
      reader.onload = (readerEvent) => {
        dispatch(createPostSlice.images(readerEvent.target.result));
      };
    });
  };
  return (
    <div data-testid="create-post-image-preview">
      <input
        type="file"
        accept="image/jpeg,image/png,image/webp,image/gif"
        multiple
        hidden
        ref={imageInputRef}
        onChange={handleImages}
        aria-label="Upload update images"
        data-testid="create-post-image-input"
      />
      <div className={styles.wrap}>
        {images && images.length > 0 ? (
          <div className={`${styles.add} ${styles.images}`}>
            <button
              type="button"
              className={styles.exit}
              aria-label="Remove images from update"
              data-testid="create-post-remove-images"
              onClick={() => dispatch(createPostSlice.type("normal"))}
            >
              <i className="exit_icon" aria-hidden="true"></i>
            </button>
            <div className={styles.preview_actions}>
              <button
                type="button"
                className={styles.actionButton}
                data-testid="create-post-add-more-images"
                onClick={() => {
                  imageInputRef.current.click();
                }}
              >
                <i className="addPhoto_icon" aria-hidden="true"></i>
                Add more photos
              </button>
            </div>
            <div
              className={`${styles.images_wrap} ${
                imgNum === 2
                  ? styles.per2
                  : imgNum === 3
                  ? styles.per3
                  : imgNum === 4
                  ? styles.per4
                  : imgNum === 5
                  ? styles.per5
                  : ""
              }`}
            >
              {images.map((img, i) => (
                <img src={img} alt={`Update attachment ${i + 1}`} key={i} />
              ))}
            </div>
          </div>
        ) : (
          <div className={styles.add}>
            <button
              type="button"
              className={styles.exit}
              aria-label="Cancel image upload"
              data-testid="create-post-cancel-image-upload"
              onClick={() => dispatch(createPostSlice.type("normal"))}
            >
              <i className="exit_icon" aria-hidden="true"></i>
            </button>
            <button
              type="button"
              className={styles.add_col}
              data-testid="create-post-select-images"
              onClick={() => {
                imageInputRef.current.click();
              }}
            >
              <div className={styles.addIcon} aria-hidden="true">
                <i className="addPhoto_icon"></i>
              </div>
              <span>Add Photos/Videos</span>
              <span>or drag and drop</span>
            </button>
          </div>
        )}
        <div className={styles.add_bottom}>
          <div className={styles.left}>
            <div className={styles.phoneIcon} aria-hidden="true">
              <i className="phone_icon"></i>
            </div>
            <span>Add photos from your mobile device</span>
          </div>
          <button
            type="button"
            className={styles.addButton}
            data-testid="create-post-mobile-add"
            onClick={() => {
              imageInputRef.current.click();
            }}
          >
            Add
          </button>
        </div>
      </div>
    </div>
  );
}

export default ImagePreview;
